import React from "react";
import {
  Typography,
  Divider,
} from "@mui/material";

export default function Article10(props: any) {

  return (
    <div>
      <title>"Who'd We Get?" - A Recap of the Giants Trade Deadline</title>
      <Typography
        variant="h4"
        component="h1"
        style={{
          fontWeight: "bold",
          color: "#000000",
          textAlign: "center",
          fontSize: props.isDesktop ? "32pt" : "20pt",
        }}
      >
        Who'd We Get?" - A Recap of the Giants Trade Deadline
      </Typography>
      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          marginBottom: "12px",
          color: "rgba(0, 0, 0, 0.7)",
          textAlign: "center",
          fontSize: props.isDesktop ? "18pt" : "14pt",
        }}
      >
        By Jackson Oleyar • August 6th, 2025
      </Typography>
      <Divider variant="middle" style={{ marginBottom: "20px" }} />

      <Typography
  variant="body2"
  style={{
    color: "rgba(0, 0, 0, 1)",
    fontSize: "13pt"
  }}
>
  Before the All-Star break, the San Francisco Giants showed promising signs of a potential playoff team. They had just traded for Rafael Devers and were looking to maintain their momentum through the break. However, since the All-Star break, the Giants have a record of 2-8. Sound the alarms - it's time to sell.
  <br /><br />
  President of Operations Buster Posey addressed the trade deadline, stating: <i>"As poorly as we played since the All-Star break, I think we all felt it was the best decision for the organization to get some pieces coming back that will help us in the future."</i> While I held hope until the break, I have to agree with Posey; given our current play, I don't think we had a shot at the title this year.
  <br /><br />
  Posey also commented on the outlook for the rest of the season: <i>"We'll probably get some different looks from different players over the next couple of months. Regardless of where you are in the standings and how poorly you played, you're just hoping to see tiny little incremental gains daily."</i>
  <br /><br />
  Posey has already shown his savvy skills, acquiring Devers earlier this year for prospects like Kyle Harrison and James Tibbs III. Dare I say, he did it again at the deadline.
  <br /><br />
</Typography>

{/* Rogers Trade */}
<div style={{
  margin: "20px 0",
  padding: "15px",
  backgroundColor: "#f8f9fa",
  borderLeft: "4px solid #0d6efd",
  borderRadius: "4px"
}}>
  <div style={{ display: "flex", marginBottom: "10px" }}>
    <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Mets Receive:</div>
    <div style={{ flex: 2, fontSize: "14pt" }}>RHP Tyler Rogers</div>
  </div>
  <div style={{ display: "flex" }}>
    <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Giants Receive:</div>
    <div style={{ flex: 2, fontSize: "14pt" }}>
      RHP <a href="/player/694918" style={{ color: "#0d6efd", textDecoration: "none" }}>Blake Tidwell</a> (NYM #10),<br />
      RHP Jose Butto,<br />
      OF <a href="/player/687551" style={{ color: "#0d6efd", textDecoration: "none" }}>Drew Gilbert</a> (NYM #12)
    </div>
  </div>
</div>

<Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
  RHP Blake Tidwell
</Typography>
<br />
<Typography
  variant="body2"
  style={{
    color: "rgba(0, 0, 0, 1)",
    fontSize: "13pt"
  }}
>
  Looking at Blake Tidwell's Prospect Savant profile, you'd notice a 4.40 ERA in AAA this year. However, deeper analysis reveals Tidwell has been one of the most unhittable starters at his level. He throws three effective fastballs (4-seam, sinker, cutter) and seven different pitches overall, many with great psStuff+. His metrics include a Z-swing% of 66.99%, chase% of 28.7%, and whiff% of 28.7%.
  <br /><br />
</Typography>

<Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
  OF Drew Gilbert
</Typography>
<br />
<Typography
  variant="body2"
  style={{
    color: "rgba(0, 0, 0, 1)",
    fontSize: "13pt"
  }}
>
  If this were the same Drew Gilbert drafted in 2022, this might have been the most one-sided trade ever. While he has cooled off from that peak hype, he remains a solid AAA hitter and outfielder for the Giants' farm system. He's a potential call-up if he catches fire and approaches his former potential.
  <br /><br />
</Typography>

{/* Yastrzemski Trade */}
<div style={{
  margin: "20px 0",
  padding: "15px",
  backgroundColor: "#f8f9fa",
  borderLeft: "4px solid #0d6efd",
  borderRadius: "4px"
}}>
  <div style={{ display: "flex", marginBottom: "10px" }}>
    <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Royals Receive:</div>
    <div style={{ flex: 2, fontSize: "14pt" }}>OF Mike Yastrzemski</div>
  </div>
  <div style={{ display: "flex" }}>
    <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Giants Receive:</div>
    <div style={{ flex: 2, fontSize: "14pt" }}>
      RHP <a href="/player/628708" style={{ color: "#0d6efd", textDecoration: "none" }}>Yunior Marte</a>
    </div>
  </div>
</div>

<Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
  RHP Yunior Marte
</Typography>
<br />
<Typography
  variant="body2"
  style={{
    color: "rgba(0, 0, 0, 1)",
    fontSize: "13pt"
  }}
>
  The Giants said goodbye to a great Giant, Mike Yastrzemski, who offered parting words: <i>"We haven't really played well enough to force them to add any more pieces."</i> He understands the MLB is a business. A good Giant beloved in the community, he will be missed.
  <br /><br />
  In return, the Giants acquired pitching prospect Yunior Marte. Though Marte has struggled in his MLB career so far, he found his footing in May, earning Pitcher of the Month in the Carolina League. He posted a 0.71 ERA in 25.1 innings, ranked 2nd in opposing average (.170), 3rd in WHIP (0.91), 8th in strikeouts (26), and 3rd in wins (3). With Columbia in 2025, he had a team-best 2.61 ERA over 51.2 innings in his first 11 starts.
  <br /><br />
</Typography>

{/* Doval Trade */}
<div style={{
  margin: "20px 0",
  padding: "15px",
  backgroundColor: "#f8f9fa",
  borderLeft: "4px solid #0d6efd",
  borderRadius: "4px"
}}>
  <div style={{ display: "flex", marginBottom: "10px" }}>
    <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Yankees Receive:</div>
    <div style={{ flex: 2, fontSize: "14pt" }}>RHP Camilo Doval</div>
  </div>
  <div style={{ display: "flex" }}>
    <div style={{ flex: 1, fontWeight: "bold", fontSize: "14pt" }}>Giants Receive:</div>
    <div style={{ flex: 2, fontSize: "14pt" }}>
      LHP Carlos De la Rosa (NYY #25),<br />
      RHP Trystan Vrieling (NYY #21),<br />
      C <a href="/player/683679" style={{ color: "#0d6efd", textDecoration: "none" }}>Jesus Rodriguez</a> (NYY #29),<br />
      3B <a href="/player/692238" style={{ color: "#0d6efd", textDecoration: "none" }}>Parks Harber</a>
    </div>
  </div>
</div>

<Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
  LHP Carlos De la Rosa
</Typography>
<br />
<Typography
  variant="body2"
  style={{
    color: "rgba(0, 0, 0, 1)",
    fontSize: "13pt"
  }}
>
  A 17-year-old left-handed pitcher from the Dominican Republic. He offers a mid-90s (touching 96 mph) fastball and is still in rookie ball.
  <br /><br />
</Typography>

<Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
  RHP Trystan Vrieling
</Typography>
<br />
<Typography
  variant="body2"
  style={{
    color: "rgba(0, 0, 0, 1)",
    fontSize: "13pt"
  }}
>
  A AA right-handed pitching prospect. He's been good lately but is a project. Drafted in 2022, he started in AA in 2024 and hasn't advanced. His arsenal includes an 80 mph curveball, mid-80s slider/cutter, and a 96 mph fastball. His career stats (46 IP, 4.50 ERA, 1.52 WHIP, 3.5 BB/9, 8.2 K/9) leave room for improvement. He profiles as a potential middle reliever if he develops.
  <br /><br />
</Typography>

<Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
  C Jesus Rodriguez
</Typography>
<br />
<Typography
  variant="body2"
  style={{
    color: "rgba(0, 0, 0, 1)",
    fontSize: "13pt"
  }}
>
  This signing is intriguing as he's the first catching prospect acquired by the best catcher of all time (Posey). Rodriguez possesses great bat-to-ball skills and defensive prowess, throwing out 36% of attempted base stealers. Since his promotion to AAA, his stats are absurd: .388/.500/.490 slash line, 175 wRC+, 18.8% BB%, 14.1% K%, 93.3% Z-Contact%, 89 mph EV, 47.2% HardHit%, 11.1% Barrel%.
  <br /><br />
</Typography>

<Typography variant="h5" style={{ color: "rgba(0, 0, 0, 1)" }}>
  3B Parks Harber
</Typography>
<br />
<Typography
  variant="body2"
  style={{
    color: "rgba(0, 0, 0, 1)",
    fontSize: "13pt"
  }}
>
  You might think this is where the Norfolk Tides play, but nope! He's a star-hitting 3B in Low-A posting video-game numbers: 95.2 mph EV (1st in level), 63.8% HardHit% (1st), and 21.3% Barrel% (6th). While older for Low-A at 24, his production is exceptional.
  <br /><br />
</Typography>

{/* Conclusion */}
<Typography variant="h4" style={{ color: "rgba(0, 0, 0, 1)", marginTop: "30px" }}>
  Season Outlook
</Typography>
<br />
<Typography
  variant="body2"
  style={{
    color: "rgba(0, 0, 0, 1)",
    fontSize: "13pt"
  }}
>
  So, what's the outlook for the remainder of the Giants' season? I don't believe the Giants are waving the white flag just yet. With pitchers Logan Webb and Robbie Ray dominating the strike zone, and big-time bats like Devers, Adames, and Chapman fully healthy, they could still steal a wildcard spot. Posey has flexibility: if the team turns it around, he can keep prospects in the minors; if the slide continues, I hope to see rising stars like Marco Luciano, Jesus Rodriguez, and Blake Tidwell gain big-league experience. Ultimately, Posey's moves have extended the Giants' contending window, positioning them very well to compete over the next three years.
  <br /><br />
  Go Giants, <br />
  Jackson Oleyar
</Typography>
    </div>
  );
}
